class NSSHeader extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.lastPos = 0;

    this.els = {
      headerGrp: document.querySelector(`nss-header-group`),
      docEl: document.documentElement,
    }

    this.open = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Header] Connected.");

    // Ensure --nss-bar-pos always has the correct value on init
    const barHeight = window.getComputedStyle(this.els.docEl).getPropertyValue(`--nss-bar-height`).trim();
    this.els.docEl.style.setProperty(`--nss-bar-pos`, barHeight);

    const debounceScroll = this.debounce(this.handleScroll.bind(this), 5);
    window.addEventListener(`scroll`, debounceScroll);

    const debounceResize = this.debounce(this.handleScroll.bind(this), 5);
    window.addEventListener(`resize`, debounceResize);

    const megaNavBtnEls = this.querySelectorAll(`[nss-mega-nav]`);

    megaNavBtnEls.forEach((megaNavBtnEl) => {
      megaNavBtnEl.addEventListener(`mouseenter`, (e) => {
        this.closeAllExpanded();
        const megaNavId = e.target.getAttribute(`nss-mega-nav`);
        e.target.setAttribute(`aria-expanded`, true);
        if (this.debug) console.log(`[NSS][Header] megaNavId:`, megaNavId);
        this.openMegaNavEvent(megaNavId);
      });
    });

    const notMegaNavBtnEls = this.querySelectorAll(`[nss-header-not-meganav-link]`);
    notMegaNavBtnEls.forEach((notMegaNavBtnEl) => {
      notMegaNavBtnEl.addEventListener(`mouseenter`, this.closeMegaNavEvent.bind(this));
    });

    const openMegaNavBtnEl = this.querySelector(`[nss-mega-nav-open]`);
    openMegaNavBtnEl.addEventListener("click", (e) => {
      if (!this.open) {
        if (this.debug) console.log(`[NSS][Header] Open Mega Nav!`);
        this.openMegaNavEvent(null);
        this.open = true;
      } else {
        if (this.debug) console.log(`[NSS][Header] Close Mega Nav!`);
        this.closeMegaNavEvent();
        this.closeAllExpanded();
        this.open = false;
      }
    });

    /*
    const closeMegaNavBtnEl = this.querySelector(`[nss-mega-nav-close]`);
    closeMegaNavBtnEl.addEventListener("click", (e) => {
      if (this.debug) console.log(`[NSS][Header] Close Mega Nav!`);
      this.closeMegaNavEvent();
      this.closeAllExpanded();
    });
    */

    this.addEventListener("megaNavClosed", (e) => {
      this.closeAllExpanded();
    });
  }

  closeAllExpanded() {
    const expandedEls = this.querySelectorAll(`[aria-expanded="true"]`);
    expandedEls.forEach((expandedEl) => {
      expandedEl.setAttribute(`aria-expanded`, false);
    });
    this.setAttribute(`nss-mega-nav-open`, false);
  }

  openMegaNavEvent(id) {
    const megaNavEl = document.querySelector(`nss-mega-nav`);
    const event = new CustomEvent("openMegaNav", { detail: id });
    megaNavEl.dispatchEvent(event);
    this.setAttribute(`nss-mega-nav-open`, true);
  }

  closeMegaNavEvent() {
    const megaNavEl = document.querySelector(`nss-mega-nav`);
    const event = new CustomEvent("closeMegaNav");
    megaNavEl.dispatchEvent(event);
    this.setAttribute(`nss-mega-nav-open`, false);
  }
  
  debounce(func, delay) {
    let timerId;
  
    return function (...args) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  handleScroll(e) {
    let pos = this.els.docEl.scrollTop;
    let scrollDown = false;
    if (pos > this.lastPos) {
      scrollDown = true;
    }

    // Announcement Bar
    const barHeight = window.getComputedStyle(this.els.docEl).getPropertyValue(`--nss-bar-height`).trim();
      let height = window.getComputedStyle(this.els.docEl).getPropertyValue(`--nss-header-height`);

      this.els.docEl.style.setProperty(`--nss-header-h`, height);
    if (scrollDown && pos > 0) {
      this.els.docEl.style.setProperty(`--nss-bar-pos`, barHeight);
    }

    if (!scrollDown && pos <= 300) {
      this.els.docEl.style.setProperty(`--nss-bar-pos`, barHeight);
    }

    // Header
    if (scrollDown && pos > 1000) {
      this.els.docEl.style.setProperty(`--nss-header-pos`, barHeight);
    }

    if (!scrollDown && pos > 32) {
      let height = window.getComputedStyle(this.els.docEl).getPropertyValue(`--nss-header-height`);
      this.els.docEl.style.setProperty(`--nss-header-pos`, height);
    }

    if (pos === 0) {
      this.els.headerGrp.classList.remove(`nss-scrolled`);
    } else {
      this.els.headerGrp.classList.add(`nss-scrolled`);
    }

    this.lastPos = pos;
  }
}

let elementName = `nss-header`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSHeader);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}